import '../styles/PageGlobal.css';
import './DevisListPage.css';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ReferenceButton from '../components/ReferenceButton';
import { DevisService } from '../services/DevisService.js';
import { AdresseService } from '../services/AdresseService.js';

export default function DevisListPage() {
  const navigate = useNavigate();
  const [devisList, setDevisList] = useState([]);
  const [addresses, setAddresses] = useState({}); // Stocke les adresses par ID
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDevis = useCallback(async () => {
    const devisService = new DevisService();
    const adresseService = new AdresseService();
    setLoading(true);
    setError(null);
    try {
      // 1. Récupérer les devis
      const data = await devisService.getAllDevis();
      setDevisList(data);

      // 2. Pour chaque devis qui a une adresse, la récupérer
      const addrMap = {};
      for (const devis of data) {
        if (devis.adresseLivraisonId) {
          try {
            const addr = await adresseService.getAdresseById(devis.adresseLivraisonId);
            addrMap[devis.adresseLivraisonId] = addr;
          } catch (e) {
            console.error(`Adresse ${devis.adresseLivraisonId} introuvable`);
          }
        }
      }
      setAddresses(addrMap);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchDevis(); }, [fetchDevis]);

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer définitivement ce devis ?")) return;
    try {
      await new DevisService().deleteDevis(id);
      fetchDevis();
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div className="devis-status devis-status-loading">Chargement…</div>;
  if (error) return <div className="devis-status devis-status-error">{error}</div>;

  return (
    <div className="containerMain devis-container">
      <div className="devis-header">
        <h1 className="devis-title">Liste des Devis</h1>
        <div className="devis-header-actions">
          <ReferenceButton to="/devis_new" className="devis-btn devis-btn-success">
            + Créer un Devis
          </ReferenceButton>
        </div>
      </div>
      <p className="devis-protected">Ceci est un contenu protégé</p>

      <div className="devis-table-wrapper">
        <table className="devis-table">
          <thead>
            <tr>
              <th>N</th>
              <th>ID Devis</th>
              <th>Client ID</th>
              <th>Adresse</th>
              <th>Date</th>
              <th>Lignes</th>
              <th>Total HT</th>
              <th>Statut</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {devisList.map((devis, index) => {
              const addr = addresses[devis.adresseLivraisonId];
              const addressText = addr 
                ? `${addr.adresse1}, ${addr.codePostal} ${addr.ville}` 
                : (devis.adresseLivraisonId || 'Aucune');

              return (
                <tr key={devis.id}>
                  <td>{index + 1}</td>
                  <td className="devis-ref">{devis.id}</td>
                  <td>{devis.clientId}</td>
                  <td>{addressText}</td>
                  <td>{devis.createdAt ? new Date(devis.createdAt).toLocaleDateString('fr-FR') : ''}</td>
                  <td>{devis.lines ? devis.lines.length : 0}</td>
                  <td>{devis.totalHT ? Number(devis.totalHT).toFixed(2) : '0.00'} €</td>
                  <td>
                    <span className={`devis-statut-badge statut-${(devis.status || 'DRAFT').toLowerCase()}`}>
                      {devis.status || 'DRAFT'}
                    </span>
                  </td>
                  <td className="devis-action-cell">
                    <button className="devis-btn devis-btn-yellow" onClick={() => navigate(`/devis_edit/${devis.id}`)}>Edit</button>
                    <button className="devis-btn devis-btn-red" onClick={() => handleDelete(devis.id)}>Suppr.</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}